import * as R from 'ramda';
import { useEffect, useState } from 'react';

import {
  ONETRUST_CONSENT_CHANGED_EVENT_TYPE,
  ONETRUST_INITIALIZED_EVENT_TYPE,
  TCF_CONSENT_CHANGED_EVENT_TYPE,
} from '@/lib/constants';
import { getTcfApi, getTCString } from '@/lib/tcf-consent';

const useConsent = () => {
  const [oneTrust, setOneTrust] = useState<typeof window.OneTrust | null>(null);
  const [isLibInitialized, setIsLibInitialized] = useState(false);
  const [currentGroups, setCurrentGroups] = useState<string[] | null>(null);
  const [tcString, setTcString] = useState<string | null>(null);

  const getCurrentGroupsFromLib = () => {
    if (typeof window?.OnetrustActiveGroups === 'string') {
      return window?.OnetrustActiveGroups.split(',').filter(Boolean).sort();
    }

    return null;
  };

  const allowAll = () => window?.OneTrust.AllowAll();

  const openCookieBanner = () => window?.OneTrust.ToggleInfoDisplay();

  useEffect(() => {
    const setupHook = () => {
      if (window?.OneTrust && oneTrust === null) {
        setOneTrust(window.OneTrust);
        setIsLibInitialized(true);
        setCurrentGroups(getCurrentGroupsFromLib());
      }
    };

    const updateTCString = async () => {
      const newTCString = await getTCString();
      setTcString((prevTCString) => {
        if (newTCString !== prevTCString) {
          document.dispatchEvent(new Event(TCF_CONSENT_CHANGED_EVENT_TYPE));

          return newTCString;
        }

        return prevTCString;
      });
    };

    document.addEventListener(
      ONETRUST_INITIALIZED_EVENT_TYPE,
      () => {
        setupHook();
        updateTCString();
      },
      false,
    );

    document.addEventListener(ONETRUST_CONSENT_CHANGED_EVENT_TYPE, () => {
      const prevGroups = currentGroups?.sort() || null;
      const newGroups = getCurrentGroupsFromLib();

      if (!R.equals(prevGroups, newGroups)) setCurrentGroups(newGroups);

      updateTCString();
    });

    const tcfApi = getTcfApi();

    if (tcfApi) {
      tcfApi('addEventListener', 2, () => {
        updateTCString();
      });
    }

    setupHook();
    updateTCString();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    OneTrust: oneTrust,
    isLibInitialized,
    currentGroups,
    tcString,
    allowAll,
    openCookieBanner,
  };
};

export default useConsent;
